/**
 * 商城管理端接口
 * 注意：http.js 中会自动去掉 /api 前缀
 */
export const mallApi = {
  // 商品管理
  goodsPage: '/api/admin/shop/goods/page',
  goodsDetail: id => `/api/admin/shop/goods/${id}`,
  goodsAdd: '/api/admin/shop/goods/add',
  goodsUpdate: '/api/admin/shop/goods/update',
  goodsDelete: id => `/api/admin/shop/goods/${id}`,
  goodsUploadImage: '/api/admin/shop/goods/upload-image',

  // 分类管理
  categoryPage: '/api/admin/shop/category/page',
  categoryList: '/api/admin/shop/category/list',
  categoryDetail: id => `/api/admin/shop/category/${id}`,
  categoryAdd: '/api/admin/shop/category/add',
  categoryUpdate: '/api/admin/shop/category/update',
  categoryDelete: id => `/api/admin/shop/category/${id}`,
  categoryUploadImage: '/api/admin/shop/category/upload-image',

  // 兑换订单管理
  exchangeOrderPage: '/api/admin/shop/exchange-order/page',
  exchangeOrderDetail: id => `/api/admin/shop/exchange-order/${id}`,
  exchangeOrderAudit: id => `/api/admin/shop/exchange-order/audit/${id}`,
  exchangeOrderDelete: id => `/api/admin/shop/exchange-order/${id}`,

  // 系统配置（通过 admin 接口查询 is_shop 等）
  systemConfigPage: '/api/admin/config/page'
}
